import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Stack, Typography } from "@mui/material";
import { AddAccountButton } from "Components/BankAccounts/BankAccountList/AddAccountButton";
import { BankAccountListActions } from "Components/BankAccounts/BankAccountList/BankAccountListActions";
import { CurrencyGroupedAccountList } from "Components/BankAccounts/BankAccountList/CurrencyGroupedAccountList";
import { InfoBox } from "Components/Shared/InfoBox/InfoBox";
import { BlDivider } from "Components/Shared/BlDivider";
import { BankAccountStatus } from "Infrastructure/Api/Api";
import type { BankAccountListItem } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";

const PageResources = Resources.Pages.Content.BankAccounts;

type Props = {
  accounts: Array<BankAccountListItem>;
  onSwitchToEditOrderRequested: () => void;
};

export const HunterBankAccountListPageContent = ({
  accounts,
  onSwitchToEditOrderRequested,
}: Props) => {
  const { t } = useResource();

  const hasNoAccount = accounts.length === 0;
  const hasMultipleAccounts = accounts.length > 1;
  const hasActiveBankAccount = accounts.some(
    ({ status }) => status === BankAccountStatus.Active,
  );

  if (hasNoAccount) {
    return (
      <>
        <InfoBox
          variant="warning"
          content={t(PageResources.MissingLicenseHolderBankAccount)}
        />
        <Typography fontSize={16} fontWeight={600}>
          {t(PageResources.NoBankAccounts)}
        </Typography>
        <AddAccountButton />
      </>
    );
  }

  return (
    <Stack>
      {!hasActiveBankAccount && (
        <InfoBox
          variant="warning"
          content={t(PageResources.MissingLicenseHolderBankAccount)}
        />
      )}
      <CurrencyGroupedAccountList accounts={accounts} />
      <Typography display="inline" mt={2} lineHeight={1.7}>
        <InfoOutlinedIcon
          sx={{ height: "1rem", width: "1rem", mb: -0.7, mr: 1 }}
        />
        {t(PageResources.HunterPrimaryAccountDescription)}
      </Typography>
      <BlDivider marginTop={6} />
      <BankAccountListActions
        hasMultipleAccounts={hasMultipleAccounts}
        onSwitchToEditOrderRequested={onSwitchToEditOrderRequested}
      />
    </Stack>
  );
};
